//If the launchAppUrl API does not return any value while running the project locally, set a default object. When running locally, update this object with client-specific details.
export let tenantConfig = {
   id: "standard",
   identifier: "standard",
   name: 'standard',
   connectionString: '',
   metadataAddress: "https://eprovidersync.b2clogin.com/eprovidersync.onmicrosoft.com/B2C_1_SH_Collaborate_Signup_Signin/v2.0/.well-known/openid-configuration",
   audience: "60242f8a-653c-4364-8ac8-7aaae90944a7",
   authority: "https://eprovidersync.b2clogin.com/eprovidersync.onmicrosoft.com/B2C_1_SH_Collaborate_Signup_Signin/v2.0",
   launchURL: "https://standard-esign-qa.simplifyhealthcare.com",
   uiClientId: "d8d8d951-2665-4ce5-a846-ae1ff17598cf"
}

export const setTenantLocalStorage = (data) => {
   const tenantId = `tenant.${data.audience}`;
   const tenantObj = JSON.stringify(data);
   sessionStorage.setItem(tenantId, tenantObj);
   localStorage.setItem(tenantId, tenantObj);
};

export const getTenantLocalStorage = () => {
   let obj = {};
   for (let [key, value] of Object.entries(localStorage)) {
      if (key.includes('tenant.')) obj = JSON.parse(value);
   }
   return obj
}

export const requestId = "2ff0e699-56cb-433d-88fe-4c173a0d47c5"

